import React from "react";
import { PropagateLoader, SquareLoader } from "react-spinners";

function Loader({
    ...props
}) {
  return (
    <SquareLoader
    color="var(--background)"
    size={10}
    {...props}
    />
  );
}

export default Loader;